import { Platform, Share } from 'react-native';

import { CAMPAIGN_URL } from '@/constants/giftingOg';

/**
 * The one campaign share URL — the landing with ?ref= attribution.
 * Built here so the secured screen and the home card can't drift apart.
 *
 * Points at `/campus-drop`, not `/season-of-gifting`: the bare directory
 * path does not resolve on EAS Hosting and served the not-found shell — and
 * with it the generic site OG — to every scraper. See the note on
 * CAMPAIGN_URL. `?ref=` is unaffected by the path change: referral capture
 * reads the query string off any URL (`lib/pendingReferral.ts`).
 */
export function campaignShareUrl(refId?: string | null): string {
  return `${CAMPAIGN_URL}${refId ? `?ref=${refId}` : ''}`;
}

/**
 * Native share sheet, platform-split the way iOS wants it (url as its own
 * field so iMessage renders the link preview). Throws on failure — callers
 * decide their fallback (the secured screen falls back to copy).
 */
export async function shareCampaignLink(message: string, url: string): Promise<void> {
  await Share.share(
    Platform.OS === 'ios' ? { message, url } : { message: `${message} ${url}` },
  );
}
